import React from 'react';

import styles from './SearchResultsHeader.module.scss';

export interface SearchResultsHeaderProps {
  query: string;
  onClear?: () => void;
}

export default function SearchResultsHeader({ query, onClear }: SearchResultsHeaderProps) {
  return (
    <div className={styles.main}>
      <span className={styles.text}>
        Showing results for: <strong>{query}</strong>
      </span>
      {onClear && (
        <button className={styles.clearButton} onClick={onClear} type="button">
          Clear search
        </button>
      )}
    </div>
  );
}
